const { rxsetLocal, rxgetLocal } = global.rootRequire('classes/request')

let initialState = {
  activeGroup:  { status: false, data: '' }
}

export const toggleGroupActive = (id) => {
  return {
    type: 'GROUP_TOGGLE',
    id: id
  }
}

export default function groupReducer (state = initialState.activeGroup, action) {
  switch (action.type) {
    case 'GROUP_TOGGLE': {
      if (!state.data) {state.data = ''}
      if (action.id) { state.data = action.id }
      if (action.id === '') { state.data = '' }
      
      let newstate = { status: !state.status, data: state.data }
      return newstate
    }

    default: {
      return state
    }
  }
}
